import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { Empty, Popconfirm } from 'antd';
import api from '../Interceptor';
import { getRoute } from '../api/routes';
import Modal from 'react-modal';
import CustomModal from '../components/customModal/customModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRefresh } from '@fortawesome/free-solid-svg-icons';
import ModalFooter from '../components/customModal/modalFooter';
import { CustomInput } from '../components/ui';
import { validateFormHandler } from '../utils/validations/validateForm';

const SuperNotifications = () => {
  const [date, setDate] = useState(new Date().toISOString().split('T')[0]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editNotification, setEditNotification] = useState(null);
  const [notificationList, setNotificationList] = useState([]);
  const [errors, setErrors] = useState({})
  const fetchNotifications = async () => {
    try {
      const response = await api.get(
        getRoute('users', 'superadmin', 'notification', false, false, '')
      );

      if (response.status === 200) {
        setNotificationList(response.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchNotifications();
  }, []);

  const handleDelete = async (id) => {
    try {
      await api.delete(
        `${getRoute(
          'users',
          'superadmin',
          'notification',
          false,
          false,
          ''
        )}?id=${id}`
      );
      fetchNotifications();
    } catch (error) {
      console.error('Error deleting notification:', error);
      toast.error('Failed to delete notification');
    }
  };

  const handleUpdate = async (updatedNotification) => {
    const notificationId = updatedNotification._id;
const hasChanged = 
          updatedNotification.title !== editNotification.title ||
          updatedNotification.description !== editNotification.description;
          if(!hasChanged){
            toast.info('No Changes Detected!');
            closeModal();
            return
          }
    const updatedPayload = {
      title: updatedNotification.title,
      description: updatedNotification.description,
      id: notificationId,
    };
    const validationErrors = validateFormHandler({
            title: updatedNotification.title,
            description: updatedNotification.description
          })
          if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
          }
    try {
      await api.patch(
        `${getRoute(
          'users',
          'superadmin',
          'notification',
          false,
          false,
          ''
        )}?id=${notificationId}`,
        updatedPayload
      );
      setIsModalOpen(false);
      toast.success('Notification updated successfully');
      fetchNotifications();
      closeModal();
    } catch (error) {
      console.error('Error updating notification:', error);
      toast.error('Error updating notification');
    }
  };

  const openEditModal = (notification) => {
    setEditNotification(notification);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setErrors({})
    setIsModalOpen(false);
    setEditNotification(null);
  };

  const handleRefresh = () => {
    setDate(new Date().toISOString().split('T')[0]);
    fetchNotifications();
  };

  const handleDateChange = (e) => setDate(e.target.value);

  const filteredNotifications = notificationList.filter(
    (notification) =>
      new Date(notification.createdAt).toLocaleDateString() ===
      new Date(date).toLocaleDateString()
  );

  return (
    <div className="rounded-xl bg-white h-full py-3 px-4 border-2 border-[#E9EAEB] font-customFont">
      <div className="flex justify-between items-center">
        <div style={{ fontFamily: 'Roboto, sans-serif' }}>
          <h1 className="font-bold text-lg md:text-xl">Notifications</h1>
          <p className="text-xs text-gray-500 font-semibold">
            View and manage notifications
          </p>
        </div>
        <div className="flex gap-3 items-center mt-2 md:mt-0">
          <button
            onClick={handleRefresh}
            className="text-black border border-[#DCE3E3] px-3 py-1 rounded-md mb-4 md:mb-0 flex items-center"
          >
            <FontAwesomeIcon icon={faRefresh}></FontAwesomeIcon>
          </button>
        </div>
      </div>
      <div className="flex flex-col md:flex-row md:space-x-3 my-4">
        <div className="flex flex-col md:w-1/6 mb-3 md:mb-0">
          <input
            type="date"
            value={date}
            onChange={handleDateChange}
            id="filterDate"
            className="border border-gray-300 py-1 px-2 w-full ring-1 ring-blue-500 rounded-md"
          />
        </div>
      </div>
      <div className="relative">
        <div className="max-h-[500px] scrollbar-hide">
          <div className="overflow-x-auto overflow-hidden rounded-lg border border-gray-200">
            <div className="min-w-[800px] sm:min-w-full rounded-lg">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-[#E9EAEB] text-[#535862] font-semibold">
                  <tr className="border-b-2">
                    <th className="px-4 py-3">Title</th>
                    <th className="px-4 py-3">Date</th>
                    <th className="px-4 py-3">Users</th>
                    <th className="px-4 py-3">Description</th>
                    <th className="px-4 py-3">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredNotifications.length > 0 ? (
                    filteredNotifications.map((notification) => (
                      <tr
                        key={notification._id}
                        className="hover:bg-gray-50 text-center transition-colors duration-200 border-t bg-white divide-y divide-gray-200 text-[#535862]"
                      >
                        <td className="px-4 py-4">{notification.title}</td>
                        <td className="px-4 py-4">
                          {new Date(
                            notification.createdAt
                          ).toLocaleDateString()}
                        </td>
                        <td className="px-4 py-4">
                          {Array.isArray(notification.assignedTo) &&
                            notification.assignedTo.length > 0 ? (
                            <ul>
                              {notification.assignedTo.map((user, index) => (
                                <li key={index}>{user.name}</li>
                              ))}
                            </ul>
                          ) : (
                            'No assigned users'
                          )}
                        </td>
                        <td className="px-4 py-4 max-w-52">
                          {notification.description}
                        </td>
                        <td className="text-right py-4 px-4 space-x-2">
                          <div className="flex gap-1 justify-center">
                            <img
                              src="../icons/Edit.svg"
                              onClick={() => openEditModal(notification)}
                              className="cursor-pointer"
                              alt="edit icon"
                            />
                            <Popconfirm
                              title="Are you sure you want to delete this user?"
                              onConfirm={() => handleDelete(notification._id)}
                              okText="Yes"
                              cancelText="No"
                            >
                              <img
                                src="../icons/Delete.svg"
                                className="cursor-pointer"
                                alt="delete icon"
                              />
                            </Popconfirm>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="5" className="py-5">
                        <Empty description="No Notifications Found" />
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <CustomModal
        isOpen={isModalOpen}
        onClose={closeModal}
        modalTitle="Edit Notification"
      >
        {editNotification && (
          <form
            onSubmit={(e) => {
              e.preventDefault();
              const formData = new FormData(e.target);

              const updatedNotification = {
                ...editNotification,
                title: formData.get('title'),
                description: formData.get('description'),
              };

              handleUpdate(updatedNotification);
            }}
            className="space-y-4"
          >
            <CustomInput
              type="text"
              label="Title"
              name="title"
              defaultValue={editNotification.title}
              onChange={()=>{
                if(errors.title){
                  setErrors((prev)=>({...prev, title:undefined}))
                }
              }}
              message={errors.title}
            />
            <CustomInput
              name="description"
              label="Description"
              defaultValue={editNotification.description}
              message={errors.description}
            />
            <ModalFooter onCancel={closeModal} />
          </form>
        )}
      </CustomModal>
    </div>
  );
};

export default SuperNotifications;
